import "./imagegrid.css";
const OneByTwoView = ({ data }) => {
  return (
    <div className="image-con">
      {data?.length > 0 &&
        data.map((img, index) => (
          <img
            key={index}
            src={img?.image__image || img?.image}
            alt="Banner"
            className={`image-item ${
              index === 0 ? "a1" : index === 1 ? "a2" : "a3"
            }`}
          />
        ))}
    </div>
  );
};

export { OneByTwoView };
